var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.166 15.833a.834.834 0 1 1 0-1.667.834.834 0 0 1 0 1.667Zm8.333-1.666h-5.987A2.496 2.496 0 0 0 9.166 12.5c-1.085 0-2 .7-2.346 1.667H2.5a.833.833 0 1 0 0 1.666h4.32A2.496 2.496 0 0 0 9.166 17.5c1.085 0 2-.7 2.346-1.667h5.987a.833.833 0 1 0 0-1.666Zm-1.666-3.334a.834.834 0 1 1 0-1.667.834.834 0 0 1 0 1.667Zm0-3.333c-1.085 0-2.001.7-2.346 1.667H2.499a.833.833 0 1 0 0 1.666h10.988a2.496 2.496 0 0 0 2.346 1.667c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5Zm-10-3.333a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667ZM2.499 5.833h.988A2.496 2.496 0 0 0 5.833 7.5c1.085 0 2-.7 2.346-1.667h9.32a.833.833 0 1 0 0-1.666H8.18A2.496 2.496 0 0 0 5.833 2.5c-1.085 0-2.001.7-2.346 1.667h-.988a.833.833 0 1 0 0 1.666Z",
    fill: "#008545"
  })));
};
export default SvgFilter;